var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatementIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 3h3v1H5zm1 5V7H4v1zm3 0V7H7v1zm-2 2V9h2v1zM6 9H4v1h2zm-2 3v-1h2v1zm5 0v-1H7v1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.268A2 2 0 0 1 5 0h3a2 2 0 0 1 1.732 1zM1 3a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z",
  clipRule: "evenodd"
})));
export default SvgStatementIcon;